import React, { useContext, useEffect, useState } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);
	const [hasPermissionError, setHasPermissionError] = useState(false);

	useEffect(() => {
		// Reseta o estado de erro de permissão quando muda de rota
		setHasPermissionError(false);
	}, [rest.location?.pathname]);
	
	// Se está carregando, mostra loading e não faz redirect
	if (loading) {
		return <BackdropLoading />;
	}
	
	// Para rotas públicas (login, signup, etc.) - renderiza diretamente
	// O redirecionamento de usuário autenticado é feito pelo handleLogin
	if (!isPrivate) {
		return <RouterRoute {...rest} component={Component} />;
	}
	
	// Para rotas privadas: verifica autenticação
	if (!isAuth) {
		return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
	}

	// Se houve erro de permissão, redireciona para home
	if (hasPermissionError) {
		return <Redirect to={{ pathname: "/" }} />;
	}

	return (
		<RouterRoute {...rest} component={Component} />
	);
};

export default Route;
